/*eslint-disable*/
import React, { useState } from "react";
import {
	Card,
	CardBody,
	Label,
	FormGroup,
	Row,
	Input,
	CardHeader,
	Col,
	Button,
	Container
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
// import SimpleHeader from "components/Headers/SimpleHeader.js";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile"

// ... (imports tetap sama)

export default function CreateKaryawanIzin() {
	const [alert, setAlert] = React.useState(null);
	const token = localStorage.token;
	let history = useHistory();
	const warehouseId = localStorage.warehouse;
	const username = localStorage.username;
	const [tipe, setTipe] = useState("");
	const [description, setDescription] = useState("");
	const [tanggal, setTanggal] = useState("");
	const [isSpinner, setIsSpinner] = useState(false);

	const handleSubmit = () => {
		// Validasi wajib
		if (!tanggal) {
			setGagalAlert("Tanggal wajib diisi!");
			return;
		}
		if (!tipe) {
			setGagalAlert("Kepentingan wajib dipilih!");
			return;
		}
		if (!description) {
			setGagalAlert("Deskripsi izin wajib diisi!");
			return;
		}

		// Tampilkan konfirmasi
		setQuestionAlert();
	};

	const CreateIzinKaryawan = () => {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		let data = {
			username: username,
			type: tipe,
			warehouse_id: parseInt(warehouseId),
			ijin_date: moment(tanggal).format("YYYY-MM-DD 00:00:00"),
			keterangan: description,
		};
		axios
			.post(`${process.env.REACT_APP_API_BASE_URL}/absensi-form/save`, data, { headers })
			.then(function (response) {
				setIsSpinner(false);
				history.push("/mobile/dispensasi-karyawan/izin/sukses-izin");
			})
			.catch(function (error) {
				setGagalAlert(error.response?.data?.message || "Terjadi kesalahan saat menyimpan data.");
				setIsSpinner(false);
			});
	};

	const setGagalAlert = (message) => {
		setAlert(
			<SweetAlert
				danger
				showConfirm
				confirmBtnText="Ok"
				title={message}
				onConfirm={hideAlert}
			/>
		);
	};

	const setQuestionAlert = () => {
		setAlert(
			<SweetAlert
				warning
				showCancel
				confirmBtnText="Lanjutkan"
				confirmBtnBsStyle="danger"
				title="Apakah Kamu Yakin?"
				onConfirm={() => {
					hideAlert();
					setTimeout(() => {
						CreateIzinKaryawan();
						setIsSpinner(true);
					}, 200); // Opsional: delay kecil agar alert sempat tertutup
				}}
				onCancel={hideAlert}
				focusCancelBtn
			/>
		);
	};

	const hideAlert = () => {
		setAlert(null);
	};

	return (
		<>
			{alert}
			{isSpinner ? (
				<Container className="mt--10 pb-10 login-container">
					<Row className="justify-content-center">
						<Col lg="5" md="7">
							<div className="d-flex flex-column align-items-center d-lg-none d-xl-none">
								<img
									src={require("assets/img/theme/loadingmobile1.gif").default}
									style={{ textAlign: "center", height: "12rem", width: "12rem", paddingTop: "1rem" }}
								/>
							</div>
						</Col>
					</Row>
				</Container>
			) : (
				<>
					<SimpleHeaderMobile to="/mobile/dispensasi-karyawan/izin" />
					<Container className="mt--6" fluid>
						<Row>
							<div className="col">
								<Row md="12">
									<Col md="12">
										<Card className="bg-secondary shadow">
											<CardHeader className="bg-white border-0">
												<div style={{ display: "flex", justifyContent: "space-between" }}>
													<h2>Buat Izin</h2>
													<div style={{ textAlign: "left" }} className="d-lg-block d-none">
														<Link className="btn btn-link" to="/mobile/dispensasi-karyawan/izin">
															<i className="fa fa-arrow-circle-left fa-2x" />
														</Link>
													</div>
												</div>
											</CardHeader>
											<CardBody>
												<FormGroup row>
													<Label className="form-control-label">Tanggal</Label>
													<Input
														className="form-control-alternative"
														autoComplete="off"
														type="date"
														value={tanggal}
														onChange={(e) => setTanggal(e.target.value)}
													/>
												</FormGroup>

												<FormGroup row>
													<Label className="form-control-label">Kepentingan</Label>
													<Input
														type="select"
														className="form-control-alternative"
														value={tipe}
														onChange={(e) => setTipe(e.target.value)}
													>
														<option value="">Pilih Kepentingan</option>
														<option value="0">Kepentingan Pribadi</option>
														<option value="1">Sakit</option>
													</Input>
												</FormGroup>

												<FormGroup row>
													<Label className="form-control-label">Deskripsi Izin</Label>
													<Input
														autoComplete="off"
														className="form-control-alternative"
														type="textarea"
														rows="4"
														placeholder="Masukan Keterangan Izin"
														value={description}
														onChange={(e) => setDescription(e.target.value)}
													/>
												</FormGroup>
											</CardBody>
											<Button color="danger" block onClick={handleSubmit}>
												Simpan
											</Button>
										</Card>
									</Col>
								</Row>
							</div>
						</Row>
					</Container>
				</>
			)}
		</>
	);
}
